import { render, staticRenderFns } from "./CustomCircleChart.vue?vue&type=template&id=24c84259&scoped=true&"
import script from "./CustomCircleChart.vue?vue&type=script&lang=ts&"
export * from "./CustomCircleChart.vue?vue&type=script&lang=ts&"
import style0 from "./CustomCircleChart.vue?vue&type=style&index=0&id=24c84259&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c84259",
  null
  
)

export default component.exports